<template>
  <v-container fluid class="hyp-table-container">
    <v-row>
      <v-col cols="auto" v-if="loading">
        <Loader text="" color="black"></Loader>
      </v-col>
      <v-col cols="11" class="title-header application-heading pull-left">
        <span>Setup Profile</span>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row v-if="displayError" class="error-details">
      <v-col cols="11">
        <span v-html="profileError"></span>
      </v-col>
      <v-col cols="1">
        <v-icon right v-on:click="clearError()">mdi-close</v-icon>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        :style="{ 'max-height': listingHeight + 'px' }"
        class="overflow-y-auto"
      >
        <v-row>
          <v-col cols="12" class="details-heading">
            <span>Mandatory Fields</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <span v-html="myIncidentsTypesDescription"></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-list dense>
              <v-row>
                <v-col cols="12" class="details-heading">
                  <span>Seerist Incident Categories</span>
                </v-col>
              </v-row>
              <template v-for="(eventCategory, i) in systemIncidentTypes">
                <v-divider
                  v-if="!eventCategory"
                  :key="`divider-${i}`"
                ></v-divider>
                <v-list-item
                  v-else
                  :key="`eventCategory-${i}`"
                  :value="eventCategory"
                  active-class="deep-green--text text--accent-4"
                >
                  <template v-slot:default="{}">
                    <v-list-item-icon>
                      <MyIncidentIcon
                        :icon="eventCategory.icon"
                      ></MyIncidentIcon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="eventCategory.title"
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-switch
                        v-model="eventCategory.enabled"
                        class="event-input-toggle pa-0 ma-0 mt-1"
                        solo
                        v-on:change="saveAndRefresh()"
                        :disabled="loading"
                      ></v-switch>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list>
            <v-row>
              <v-col cols="auto" class="details-heading">
                <span>Custom Incident Categories</span>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  small
                  fab
                  color="success"
                  title="Add new custom category"
                  class="add-button"
                  @click="addCustomCategory()"
                >
                  <v-icon x-small>fas fa-solid fa-plus</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-col>
                <v-list dense>
                  <template v-for="(category, i) in customIncidentCategories">
                    <v-list-item
                      :key="`category-${i}`"
                      :value="category"
                      active-class="deep-green--text text--accent-4"
                    >
                      <template v-slot:default="{}">
                        <v-list-item-icon>
                          <MyIncidentIcon
                            :icon="category.icon"
                            :iconSize="20"
                          ></MyIncidentIcon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-row>
                            <v-col class="py-0">
                              <v-text-field
                                v-if="editingCustomCategoryId === category.id"
                                v-model="category.title"
                                size="50"
                                :ref="`category${category.id}`"
                                :rules="specialCharactersRule"
                              />
                              <v-list-item-title
                                v-text="category.title"
                                v-if="editingCustomCategoryId !== category.id"
                              ></v-list-item-title>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="py-0">
                              <v-select
                                v-if="editingCustomCategoryId === category.id"
                                v-model="category.icon"
                                :items="customIcons"
                                item-text="text"
                                item-value="value"
                                label="Select An Icon"
                                single-line
                                clearable
                                class="pt-0"
                                :rules="[(v) => !!v || 'Icon is required']"
                              >
                                <template v-slot:selection="{ item }">
                                  <img
                                    :src="getIcon(item)"
                                    alt
                                    class="icon mr-2"
                                  />
                                  {{ item.text }}
                                </template>
                                <template v-slot:item="{ item }">
                                  <img
                                    :src="getIcon(item)"
                                    alt
                                    class="icon mr-2"
                                  />
                                  {{ item.text }}
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-list-item-content>

                        <v-icon
                          small
                          v-show="editingCustomCategoryId !== category.id"
                          v-on:click.prevent="
                            toggleEditCustomCategory(category)
                          "
                          :disabled="loading"
                          >mdi-pencil
                        </v-icon>
                        <v-list-item-action>
                          <v-switch
                            v-model="category.enabled"
                            class="event-input-toggle"
                            solo
                            v-show="editingCustomCategoryId !== category.id"
                            v-on:change="saveCustomCategory()"
                            :disabled="loading"
                          ></v-switch>
                          <div
                            class="pull-right"
                            v-show="editingCustomCategoryId === category.id"
                          >
                            <v-btn
                              small
                              class="btn primary mt-4"
                              @click.prevent="saveCustomCategory()"
                            >
                              Save
                            </v-btn>
                            <v-btn
                              small
                              class="btn ml-2 mt-4"
                              @click.prevent="cancelEditCategory()"
                            >
                              Cancel
                            </v-btn>
                          </div>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col cols="12" class="details-heading">
            <span>Optional Fields</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <span v-html="myIncidentsOptionalFieldsDescription"></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-list>
              <template
                v-for="(optionalField, i) in seeristEventOptionalFields"
              >
                <v-divider
                  v-if="!optionalField"
                  :key="`divider-${i}`"
                ></v-divider>
                <v-list-item
                  v-else
                  :key="`optionalField-${i}`"
                  :value="optionalField"
                  active-class="deep-green--text text--accent-4"
                >
                  <template v-slot:default="{}">
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="optionalField.title"
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-switch
                        v-model="optionalField.enabled"
                        class="event-input-toggle pa-0 ma-0 mt-1"
                        solo
                        v-on:change="saveOptionalField(optionalField)"
                        :disabled="loading"
                      ></v-switch>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col cols="auto" class="details-heading">
            <span>Custom Fields</span>
          </v-col>
          <v-col cols="auto">
            <v-btn
              small
              fab
              color="success"
              title="Add new custom field"
              class="add-button"
              @click="addCustomField()"
            >
              <v-icon x-small>fas fa-solid fa-plus</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <span v-html="myIncidentsCustomFieldsDescription"></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-list>
              <template v-for="(item, i) in customFields">
                <v-list-item
                  :key="`item-${i}`"
                  :value="item"
                  active-class="deep-green--text text--accent-4"
                >
                  <template v-slot:default="{}">
                    <v-list-item-content>
                      <div v-if="editedFieldId === item.id">
                        <v-text-field
                          v-model="item.title"
                          size="50"
                          :ref="`field${item.id}`"
                          :rules="specialCharactersRule"
                        />
                      </div>
                      <v-list-item-title
                        v-text="item.title"
                        v-if="editedFieldId !== item.id"
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-icon
                      small
                      v-show="editedFieldId !== item.id"
                      v-on:click.prevent="toggleEditCustomField(item)"
                      :disabled="loading"
                      >mdi-pencil
                    </v-icon>
                    <v-list-item-action>
                      <v-switch
                        v-model="item.enabled"
                        class="event-input-toggle pa-0 ma-0 mt-1"
                        solo
                        v-show="editedFieldId !== item.id"
                        v-on:change="saveCustomFields()"
                        :disabled="loading"
                      ></v-switch>
                      <div
                        class="pull-right"
                        v-show="editedFieldId === item.id"
                      >
                        <v-btn
                          small
                          class="btn primary mt-4"
                          @click.prevent="saveCustomFields()"
                        >
                          Save
                        </v-btn>
                        <v-btn
                          small
                          class="btn ml-2 mt-4"
                          @click.prevent="cancelEdit()"
                        >
                          Cancel
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import {
  MY_INCIDENTS_TYPES_DESCRIPTION,
  MY_INCIDENTS_OPTIONAL_FIELDS_DESCRIPTION,
  MY_INCIDENTS_CUSTOM_FIELDS_DESCRIPTION,
  MY_INCIDENTS_CUSTOM_ICONS,
} from "@/common/constants/myIncidents";
import { MODULE_PREFIX_MY_INCIDENTS } from "@/store";
import {
  GET_MY_INCIDENTS_REFRESH_MAP,
  GET_MY_INCIDENTS_PROFILE,
  SAVE_MY_INCIDENTS_PROFILE,
  CLEAR_MY_INCIDENTS_PROFILE_ERROR,
} from "@/store/actions.type";
import lodashOrderBy from "lodash/orderBy";

export default {
  name: "MyIncidentsSetup",
  components: {
    Loader: () => import("@/components/common/Loader"),
    MyIncidentIcon: () => import("@/components/myIncidents/MyIncidentIcon"),
  },
  data() {
    return {
      customFields: [],
      customIcons: MY_INCIDENTS_CUSTOM_ICONS,
      editedFieldId: "",
      editingCustomCategoryId: "",
      customIncidentCategories: [],
      systemIncidentTypes: [],
      myIncidentsTypesDescription: MY_INCIDENTS_TYPES_DESCRIPTION,
      myIncidentsOptionalFieldsDescription: MY_INCIDENTS_OPTIONAL_FIELDS_DESCRIPTION,
      myIncidentsCustomFieldsDescription: MY_INCIDENTS_CUSTOM_FIELDS_DESCRIPTION,
      severity: "Severity",
      incidentTime: "Incident Time",
      seeristEventOptionalFields: [
        {
          id: 1,
          title: "Severity",
          enabled: false,
        },
        {
          id: 2,
          title: "Incident Time",
          enabled: false,
        },
      ],
      specialCharactersRule: [
        (value) =>
          /^[\w\s]+$/.test(value) ||
          "Alphabets, numeric and space are only allowed",
      ],
      windowSize: {
        x: 0,
        y: 0,
      },
      loading: false,
    };
  },
  async mounted() {
    await this.getProfile();
    this.handleResize();
  },
  computed: {
    ...mapGetters({
      profile: MODULE_PREFIX_MY_INCIDENTS + "profile",
      profileError: MODULE_PREFIX_MY_INCIDENTS + "profileError",
    }),
    listingHeight() {
      return this.windowSize.y - 250;
    },
    displayError() {
      return !!this.profileError;
    },
  },
  methods: {
    ...mapActions({
      clearError: MODULE_PREFIX_MY_INCIDENTS + CLEAR_MY_INCIDENTS_PROFILE_ERROR,
      getProfile: MODULE_PREFIX_MY_INCIDENTS + GET_MY_INCIDENTS_PROFILE,
      saveProfile: MODULE_PREFIX_MY_INCIDENTS + SAVE_MY_INCIDENTS_PROFILE,
      refreshMap: MODULE_PREFIX_MY_INCIDENTS + GET_MY_INCIDENTS_REFRESH_MAP,
    }),
    initialize() {
      // setup event categories of this profile
      this.systemIncidentTypes = lodashOrderBy(
        this.profile.incidentTypes.filter(({ isSystemType }) => isSystemType),
        ["title"],
        ["asc"]
      );

      this.initializeCustomCategories();

      // show the optional fields
      this.seeristEventOptionalFields.forEach((field) => {
        switch (field.title) {
          case this.severity:
            field.enabled = this.profile.severityEnabled;
            break;
          case this.incidentTime:
            field.enabled = this.profile.incidentTimeEnabled;
            break;
          // Add more cases for other custom types
        }
      });
      this.populateCustomFields();
    },
    initializeCustomCategories() {
      this.customIncidentCategories = this.profile.incidentTypes
        .filter(({ isSystemType }) => !isSystemType)
        .map(({ title, enabled, icon }, i) => {
          return {
            id: i,
            title,
            enabled,
            icon,
          };
        });
    },
    addCustomCategory() {
      if (this.editingCustomCategoryId !== "") {
        return;
      }

      this.customIncidentCategories.push({
        id: this.customIncidentCategories.length,
        title: "New Custom Category",
        enabled: false,
        icon: this.customIcons[0].value,
      });
      this.editingCustomCategoryId = this.customIncidentCategories.length - 1;
    },
    populateCustomFields() {
      this.customFields = Object.entries(this.profile.customFields ?? {}).map(
        ([k, v], i) => {
          return {
            id: i,
            title: k,
            enabled: v,
          };
        }
      );
    },
    async saveOptionalField(item) {
      // case to evaluate what item is being updated
      switch (item.title) {
        case this.severity:
          this.profile.severityEnabled = item.enabled;
          break;
        case this.incidentTime:
          this.profile.incidentTimeEnabled = item.enabled;
          break;
      }
      await this.saveAndRefresh();
    },
    handleResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    async saveAndRefresh() {
      this.loading = true;
      await this.saveProfile(this.profile);
      await this.refreshMap(new Date().toISOString());
      this.loading = false;
    },
    async refresh() {
      this.loading = true;
      await this.getProfile();
    },
    toggleEditCustomField(item) {
      this.editedFieldId = item.id;
    },
    toggleEditCustomCategory(category) {
      this.editingCustomCategoryId = category.id;
    },
    async saveCustomFields() {
      this.editedFieldId = "";
      this.profile.customFields = this.customFields
        .filter(({ title }) => title.length > 0)
        .reduce((acc, { title, enabled }) => {
          acc[title] = enabled;
          return acc;
        }, {});
      await this.saveAndRefresh();
    },
    cancelEdit() {
      this.editedFieldId = "";
      this.populateCustomFields();
    },
    cancelEditCategory() {
      this.editingCustomCategoryId = "";
      this.initializeCustomCategories();
    },
    addCustomField() {
      const newField = {
        id: this.customFields.length,
        title: "New Custom Field",
        enabled: false,
      };
      this.customFields.push(newField);
      this.editedFieldId = newField.id;
    },
    async saveCustomCategory() {
      this.editingCustomCategoryId = "";
      this.profile.incidentTypes = [
        ...this.systemIncidentTypes,
        ...this.customIncidentCategories.map(({ title, enabled, icon }) => {
          return {
            title,
            enabled,
            icon,
          };
        }),
      ];
      await this.saveAndRefresh();
    },
    getIcon(item) {
      try {
        return require(`@/assets/images/icons/${item.fileName}`);
      } catch (e) {
        return null;
      }
    },
  },
  watch: {
    profile: {
      handler() {
        this.loading = false;
        this.initialize();
      },
    },
  },
};
</script>
<style scoped>
.hyp-table-container {
  width: 1200px;
}

.details-heading {
  font-size: 18px;
  font-weight: bold;
}

.title-header {
  font-size: 26px;
  font-weight: bold;
}

.add-button {
  max-height: 18px;
  max-width: 18px;
}

.icon {
  width: 20px;
  height: 20px;
}

.error-details {
  background-color: #c10000;
  color: #ffffff;
  font-weight: bold;
}
</style>
